// extracted by mini-css-extract-plugin
module.exports = {"table":"index_table__1N1IW"};